import React, { useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { Box, Grid } from '@mui/material';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TuneIcon from '@mui/icons-material/Tune';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import GenericFilter from './GenericFilter';
import GenericFilterChip from './GenericFilterChip';
import { resetFilterDataState } from '../../modules/filter/filterAction';
import { useDispatch } from 'react-redux';
import { RESET_DATE_RANGE, RESET_SELECTED_MONTH_RANGE } from '../../constants';

const drawerWidth = 340;

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-start',
}));

function GenericFilterDrawer(props) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const dispatch = useDispatch();

  const { options, disableDateRange, monthRangePicker = false } = props;
  const theme = useTheme();
  const handleDrawerOpen = () => {
    setOpenDrawer(!openDrawer);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  const formResetHandler = () => {
    dispatch(resetFilterDataState());

    monthRangePicker
      ? dispatch({
          type: RESET_SELECTED_MONTH_RANGE,
        })
      : dispatch({
          type: RESET_DATE_RANGE,
        });
  };

  return (
    <>
      <Grid container className="head-title-text" sx={{ alignItems: 'center' }}>
        <Grid item md={12}>
          <Grid
            className="align-container-inline"
            sx={{ alignItems: 'center', mr: 4, ml: 4, marginLeft: '0px' }}
          >
            <IconButton
              tabIndex={0}
              title="Filter"
              aria-label="Filter"
              variant="standard"
              onClick={handleDrawerOpen}
            >
              <TuneIcon fontSize="medium" sx={{ transform: 'scaleZ(-1 )' }} />
            </IconButton>

            <GenericFilterChip />

            <Box sx={{ display: 'flex' }}>
              <Drawer
                sx={{
                  width: drawerWidth,
                  flexShrink: 0,
                  '& .MuiDrawer-paper': {
                    width: drawerWidth,
                  },
                }}
                variant="persistent"
                anchor="right"
                open={openDrawer}
              >
                <DrawerHeader>
                  <IconButton onClick={handleDrawerClose}>
                    {theme.direction === 'rtl' ? (
                      <ChevronLeftIcon />
                    ) : (
                      <ChevronRightIcon />
                    )}
                  </IconButton>
                  <IconButton
                    style={{ marginLeft: 'auto' }}
                    onClick={formResetHandler}
                  >
                    <RestartAltIcon />
                  </IconButton>
                </DrawerHeader>
                <Divider />

                <GenericFilter
                  options={options}
                  handleDrawerOpen={handleDrawerOpen}
                  disableDateRange={disableDateRange}
                  monthRangePicker={monthRangePicker}
                />
              </Drawer>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default GenericFilterDrawer;
